import React from "react";
import TeamManagement from "../TeamManagement";

const TeamWidget = ({ employees, user }) => (
  <div className="widget-content-scroll">
    <TeamManagement employees={employees || []} user={user} />
  </div>
);

export default TeamWidget;
